if (!customElements.get('fesco-variant-table')) {
  customElements.define('fesco-variant-table', class FescoVariantTable extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const row = event.target.closest('[data-variant-row]');
        if (row && !event.target.matches('input')) this.selectRow(row);
      });
      this.addEventListener('keydown', (event) => {
        if (!['Enter', ' '].includes(event.key)) return;
        const row = event.target.closest('[data-variant-row]');
        if (!row) return;
        event.preventDefault();
        this.selectRow(row);
      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.querySelectorAll('[data-variant-row]').forEach((row) => {
          const selected = row.contains(event.target);
          row.classList.toggle('is-selected', selected);
          row.setAttribute('aria-checked', String(selected));
        });
      });
      this.loadSpecs();
    }

    async loadSpecs() {
      const status = this.querySelector('.fesco-variant-table__status');
      try {
        const response = await fetch(this.dataset.specsUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const product = (await response.json())[this.dataset.productHandle];
        if (!product) throw new Error('Product specifications were not found');
        this.querySelector('[data-table-heading]').innerHTML = product.columns.map((column) => `<th scope="col">${this.escape(column)}</th>`).join('');
        this.querySelectorAll('[data-variant-row]').forEach((row) => {
          const cells = product.rows[row.dataset.sku.toUpperCase()];
          if (!cells) return;
          row.cells[0].querySelector('.fesco-variant-table__sku').textContent = cells[0];
          while (row.cells.length > 1) row.deleteCell(1);
          cells.slice(1).forEach((value) => { const cell = row.insertCell(); cell.textContent = value; });
        });
      } catch (error) {
        if (status) status.textContent = '仕様表を読み込めませんでした。サイズ選択は引き続きご利用いただけます。';
      }
    }

    selectRow(row) {
      const input = row.querySelector('input[type="radio"]');
      if (!input || input.checked) return;
      const variantId = row.dataset.variantId;
      if (variantId) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((variantInput) => {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', nextUrl);
      }
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    escape(value) { const element = document.createElement('span'); element.textContent = value; return element.innerHTML; }
  });
}
